import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    createdAt: {
      name: 'เวลา',
      width: '12rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
    action: {
      name: 'รายละเอียด',
      width: '1fr',
    },
  },
};
